import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Trophy, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background px-6">
      <div className="text-center animate-slide-up">
        <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-6">
          <Trophy className="h-8 w-8 text-primary-foreground" />
        </div>
        <div className="text-7xl font-extrabold tracking-tight text-muted-foreground/30 mb-4 kpi-value">404</div>
        <h1 className="text-2xl font-bold tracking-tight mb-2">Page not found</h1>
        <p className="text-muted-foreground text-sm max-w-sm mx-auto mb-8 leading-relaxed">
          This page doesn't exist or may have been moved. Head back to your command center.
        </p>
        <Button asChild>
          <Link href="/dashboard">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Link>
        </Button>
      </div>
    </div>
  );
}
